module.exports = __webpack_public_path__ + "static/media/EMOJI-101-badge.3fc88a19.svg";